import { LayerSummary } from '../../types'

export enum TimelineEventType {
  EditsGroup = 'EditsGroup',

  /*
   * Suggestions
   */
  ArticleSuggestionReviewsCreated = 'Event::ArticleSuggestionReviewsCreated',
  ArticleSuggestionReminder = 'Event::ArticleSuggestionReminder',
  ArticleSuggestionCancelled = 'Event::ArticleSuggestionCancelled',
  ArticleSuggestionReviewRejected = 'Event::ArticleSuggestionReviewRejected',
  ArticleSuggestionApprovedAndMerged = 'Event::ArticleSuggestionApprovedAndMerged',

  /*
   * Approvals
   */
  ArticleReviewRequestApprovedAndMerged = 'Event::ArticleReviewRequestApprovedAndMerged',
  ArticleReviewCancel = 'Event::ArticleReviewCancel',
  ArticleReviewRejection = 'Event::ArticleReviewRejection',
  ArticleReviewRequest = 'Event::ArticleReviewRequest',
  ArticleReviewReminder = 'Event::ArticleReviewReminder',

  /*
   * Informal feedback requests
   */
  ArticleInformalFeedbackReviewsCreated = 'Event::ArticleInformalFeedbackReviewsCreated',
  ArticleInformalFeedbackViewersCreated = 'Event::ArticleInformalFeedbackViewersCreated',
  ArticleInformalFeedbackViewersCoCreated = 'Event::ArticleInformalFeedbackViewersCoCreated',
  ArticleInformalFeedbackReviewSubmitted = 'Event::ArticleInformalFeedbackReviewSubmitted',
  ArticleInformalFeedbackReviewDismissed = 'Event::ArticleInformalFeedbackReviewDismissed',
  ArticleInformalFeedbackRequestClosed = 'Event::ArticleInformalFeedbackRequestClosed',

  /*
   * Read receipts
   */
  ArticleEndReadReceipt = 'Event::ArticleEndReadReceipt',
  ArticleReadReceiptRequest = 'Event::ArticleReadReceiptRequest',
  ArticleMarkedAsRead = 'Event::ArticleMarkedAsRead',
  ArticleAllTasksMarkedAsRead = 'Event::ArticleAllTasksMarkedAsRead',

  /*
   * Version control
   */
  ArticleCopy = 'Event::ArticleCopy',
  ArticleBranchCreated = 'Event::ArticleBranchCreated',
  ArticleMerged = 'Event::ArticleMerged',
  ArticleMergedInto = 'Event::ArticleMergedInto',
  ArticleEventRestored = 'Event::ArticleEventRestored',

  /*
   * AI
   */

  ArticleAIGeneratedEvent = 'Event::GenerateAIDoc',
  ArticleAIRevisionAcceptedEvent = 'Event::AIRevisionAccepted',

  /*
   * Comments
   */
  CommentsGroup = 'CommentsGroup',
  RepliesGroup = 'RepliesGroup',

  /*
   * Todos
   */
  CreateTodo = 'Event::CreateTodo',
  CompleteTodo = 'Event::CompleteTodo',

  /*
   * Sharing
   */
  GrantArticleAccess = 'Event::GrantArticleAccess',

  /*
   * Origin
   */
  ArticleCreated = 'Event::ArticleCreate',

  ArticleLastViewed = 'Event::ArticleLastViewed',

  /*
   * Layers
   */
  LayerCreated = 'Event::LayerCreated',
  LayerDeleted = 'Event::LayerDeleted',
  LayerMerged = 'Event::LayerMerged',

  /**
   * Workflows
   */
  WorkflowStatusUpdated = 'Event::WorkflowStatusUpdated',

  /**
   * VCM
   */
  VcmChanged = 'Event::AlmanacFileVcmChanged',
}

export interface TimelineEventInitiator {
  avatar_url: string | null
  display_name: string | null
  id: number
}

export interface TimelineEvent {
  id: string
  version: number
  timestamp: string
  data: any
  type: TimelineEventType
  name: string | null
  article: {
    slug: string
    key: string
    title: string
    header_emoji?: string | null
  }
  layer: LayerSummary
  user?: TimelineEventInitiator
  is_current?: boolean
  isNew?: boolean
  // Check if need deprecation
  user_count?: number
  last_viewed: boolean
  last_timestamp?: string
}

export interface Timeline {
  events: TimelineEvent[]
  more_available: boolean
  oldest_timestamp?: string
}
